import { coerceArray } from '@angular/cdk/coercion';
import { FeatureDecisionService } from '../services/feature-decision/feature-decision.service';
import { BaseCondition } from './base-condition';
import { ProvinceEnum } from 'src/app/shared/constants/province.enum';

export class ProvinceCondition implements BaseCondition {
  private allowedProvinces: Array<ProvinceEnum> = [];

  constructor(allowedProvinces: ProvinceEnum | Array<ProvinceEnum>) {
    this.allowedProvinces = coerceArray(allowedProvinces);
  }

  isAllowed(service: FeatureDecisionService): boolean {
    return this.allowedProvinces.includes(service.province);
  }
}
